export const generateArrayToObject = (array: string[], defaultValue: boolean) => {
    const result: any = {};
    array.forEach((element) => {
        result[`id${element}`] = defaultValue;
    });
    return result;
};
